// extracted by mini-css-extract-plugin
module.exports = {"inviteFooterP":"inviteFooterP--3gPAZ","span1":"span1--10M5b","span2":"span2--2Ye2x","return":"return--2FEAx"};